import styled from 'styled-components';

export const UploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  height: 100%;
  min-height: 250px;
  color: #555;
`;

export const ImagePreview = styled.img`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 15px;
  border: 2px solid #ddd;
  cursor: pointer;
`;

export const UploadButton = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  background-color: #003366;
  color: white;
  font-size: 14px;
  cursor: pointer;
  margin-top: 10px;
  &:hover {
    background-color: #002244;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

